/* eslint-disable no-negated-condition */
export const norm = (url?: string) => (url ? (url.startsWith('/') ? url : `/${url}`) : '/');

// Quita barras finales, pero respeta la raíz "/"
export const trimSlash = (p: string) => (p !== '/' ? p.replace(/\/+$/, '') : p);
